import { render } from "./ModalCreateUpdateDelivery.vue?vue&type=template&id=5463212c"
import script from "./ModalCreateUpdateDelivery.vue?vue&type=script&lang=js"
export * from "./ModalCreateUpdateDelivery.vue?vue&type=script&lang=js"

import "./ModalCreateUpdateDelivery.vue?vue&type=style&index=0&id=5463212c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__